import { CoreInputEditorType } from '../constants/dev-extreme-enums';
import { CoreFormItemType } from '../constants/enums';
import { CoreEditorOptions } from './core-editor-options';
import { CoreFormFieldProperties } from './core-form-field-properties';
import { Xaction } from './xaction';

export class SellerSnapshotFormFieldProperties extends CoreFormFieldProperties {
    items: SellerSnapshotFormFieldProperties[];
    heightValue: number;
    gridColumns: string[];
    gridData: Xaction[];
    gridFilterObject: any;

    createSimpleItem(dataField: string, label: string, value: any, dataset: any[], editorType: CoreInputEditorType, colSpan: number = 1, readOnly: boolean = false,
        displayExpr: string = 'name', valueExpr: string = 'id', heightValue: number = null, gridColumns: string[] = null, gridFilterObject: any = null): SellerSnapshotFormFieldProperties {
        this.itemType = CoreFormItemType.Simple;
        this.dataField = dataField;
        this.label = { text: label, visible: true };
        this.editorType = editorType;
        this.dataset = dataset;
        this.colSpan = colSpan;
        this.heightValue = heightValue;
        this.gridColumns = gridColumns;
        this.gridFilterObject = gridFilterObject;

        if (editorType === CoreInputEditorType.TextBox || editorType === CoreInputEditorType.TextArea || editorType === CoreInputEditorType.CheckBox
            || editorType === CoreInputEditorType.NumberBox) {
            this.editorOptions = new CoreEditorOptions().textBox(null, null, readOnly, undefined, value);
        } else if (editorType === CoreInputEditorType.SelectBox || editorType === CoreInputEditorType.Lookup) {
            this.editorOptions = new CoreEditorOptions().selectBox(dataset, null, null, displayExpr, valueExpr, readOnly, value, false);
        }
        
        return this;
    }

    createGroupItem(colSpan: number, colCount: number, labelText: string, items: SellerSnapshotFormFieldProperties[], dataField: string): SellerSnapshotFormFieldProperties {
        this.itemType = CoreFormItemType.Group;
        this.label = { text: labelText, visible: true };
        this.colSpan = colSpan;
        this.colCount = colCount;
        this.items = items;
        // This allows group items to be uniquely identified
        this.dataField = dataField;

        return this;
    }

    createEmptyItem(colSpan: number): SellerSnapshotFormFieldProperties {
        this.itemType = CoreFormItemType.Empty;
        this.colSpan = colSpan;

        return this;
    }

    addOnValueChangedFunction(parentThis: any, onValueChangedFunction: (e: any, cellInfo: any) => void): SellerSnapshotFormFieldProperties {
        this.editorOptions.onValueChanged = onValueChangedFunction.bind(parentThis, { dataField: this.dataField });

        return this;
    }

    addTemplate(template: string): SellerSnapshotFormFieldProperties {
        this.template = template;

        return this;
    }

    setLabelVisible(visible: boolean): SellerSnapshotFormFieldProperties {
        const labelText = ((typeof this.label === 'string' || this.label instanceof String) ? this.label : this.label['text']).toString();
        this.label = { text: labelText, visible: visible };

        return this;
    }
}
